// extracted by mini-css-extract-plugin
export var fullGrid = "_38-3";
export var pdpPreviewContainer = "_38-1";
export var previewContainer = "_38-0";
export var togglePreviewContainer = "_38-2";